import { render, staticRenderFns } from "./lessonDetail.vue?vue&type=template&id=5872f004&scoped=true"
import script from "./lessonDetail.vue?vue&type=script&lang=js"
export * from "./lessonDetail.vue?vue&type=script&lang=js"
import style0 from "./lessonDetail.vue?vue&type=style&index=0&id=5872f004&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872f004",
  null
  
)

export default component.exports